'use strict';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import StringHelper from '../../global/StringHelper';
import Icons from '../../siteSearch/components/Icons';
import SuggestType from '../../siteSearch/enums/SuggestType';
import SearchSuggest from '../../siteSearch/model/SearchSuggest';
import UiHelper from '../../siteSearch/ui/UiHelper';
import sxQuery from '../../sxQuery/sxQuery';
import SxQueryUtils from '../../sxQuery/SxQueryUtils';
import BlockEntryType from '../enums/BlockEntryType';
import CategoryStyle from '../enums/CategoryStyle';
import ImagePosition from '../enums/ImagePosition';
import SuggestionStyle from '../enums/SuggestionStyle';
import SuggestLayoutType from '../enums/SuggestLayoutType';
import DataPointType from '../interface/DataPointType';
import Helper from '../utils/Helper';
var DEFAULT_LAYOUT_CONFIGURATION = {
    type: SuggestLayoutType.List,
    imagePosition: ImagePosition.Left,
    showTitle: true,
    showSnippet: false,
    showUrl: false,
    gridColsSm: 1,
    gridColsMd: 2,
    gridColsLg: 3,
    gridColsXl: 3,
    icon: undefined,
    title: undefined
    // separator: false
};
var ACTIVE_TAB_CLASS_NAME = 'unibox__menu-item--active unibox-ac-b';
var SuggestionBlock = /** @class */ (function () {
    function SuggestionBlock(dataSet, layoutConfiguration, dataPoints, categoryStyle, config, style, interpretedQuery) {
        this.dataSet = dataSet;
        // @ts-ignore
        this.layoutConfiguration = layoutConfiguration !== undefined ? SxQueryUtils.extend(JSON.parse(JSON.stringify(DEFAULT_LAYOUT_CONFIGURATION)), layoutConfiguration) : DEFAULT_LAYOUT_CONFIGURATION;
        this.clusterId = Math.round(100000 * Math.random()).toString();
        this.dataPoints = dataPoints || [];
        this.categoryStyle = categoryStyle;
        this.activeContentGroup = '*';
        this.config = config;
        this.style = style || SuggestionStyle.Standard;
        this.empty = false;
        this.interpretedQuery = interpretedQuery;
    }
    SuggestionBlock.prototype.isShowCta = function () {
        return this.layoutConfiguration.cta !== undefined && this.dataSet.data.length > 0;
    };
    SuggestionBlock.prototype.render = function (highlight, searchQuery, selectCallback, submitCallback, suggestLineCallback, deleteCallback, viewKeyMappings, groupChangeCallback, accentColor, hideHandler, suggestRenderer, numberOfBlocks) {
        var _this = this;
        // TODO: aria-label for cluster
        var contentGroup = this.dataSet.data.length > 0 ? this.dataSet.data[0].contentGroup : undefined;
        var clusterTypeId = contentGroup ? " unibox__cluster--".concat(StringHelper.getSafeKey(contentGroup)) : '';
        var wrap = sxQuery("<section class=\"unibox-n-section unibox__cluster unibox__cluster--type-".concat(this.dataSet.type, " unibox__cluster--layout-").concat(this.layoutConfiguration.type, " unibox__cluster--style-").concat(this.style).concat(clusterTypeId, "\"></section>"));
        if (contentGroup && this.config.clusterClassMap && this.config.clusterClassMap[StringHelper.getSafeKey(contentGroup)]) {
            wrap.addClass(this.config.clusterClassMap[StringHelper.getSafeKey(contentGroup)]);
        }
        if (this.layoutConfiguration.type === SuggestLayoutType.Grid) {
            var clusterId_1 = "unibox-cluster-".concat(this.clusterId);
            wrap.attr('id', clusterId_1);
            var style_1 = '';
            var breakpoints = [
                { type: 'max', val: 767, cols: this.layoutConfiguration.gridColsSm },
                { type: 'max', val: 991, cols: this.layoutConfiguration.gridColsMd },
                { type: 'min', val: 992, cols: this.layoutConfiguration.gridColsLg },
                { type: 'min', val: 1200, cols: this.layoutConfiguration.gridColsXl }
            ];
            // TODO: IE11,...
            breakpoints.forEach(function (bp) {
                var ctaStyle = _this.isShowCta() ? "#".concat(clusterId_1, " .unibox__selectable--cta { grid-column: ").concat(bp.cols, "; }") : '';
                style_1 += "@media(".concat(bp.type, "-width:").concat(bp.val, "px){#").concat(clusterId_1, "{grid-template-columns: ").concat(new Array(bp.cols + 1).join('1fr '), ";}").concat(ctaStyle, "}");
            });
            wrap.append("<style type=\"text/css\">".concat(style_1, "</style>"));
        }
        var isFirstRender = true;
        var renderDataSet = function (data) {
            var oldSelectablesLength = (_this.selectables || []).length;
            _this.selectables = [];
            var layoutTitle = _this.layoutConfiguration.title;
            var lastContentGroup = layoutTitle;
            data.forEach(function (entry, idx) {
                if (_this.categoryStyle === CategoryStyle.Titles && lastContentGroup !== entry.contentGroup) {
                    var viewKey = viewKeyMappings[entry.contentGroup] !== undefined ? viewKeyMappings[entry.contentGroup] : entry.contentGroup;
                    if (numberOfBlocks === 1 && entry.contentGroup === '_') { // do not show other title if there is only a single content group
                        viewKey = '';
                    }
                    if (viewKey === undefined || viewKey === null || viewKey.length === 0) {
                        viewKey = layoutTitle;
                    }
                    if (viewKey !== undefined && viewKey !== null && viewKey.length > 0) {
                        wrap.append("<h2 class=\"unibox__suggest-heading\">".concat(viewKey, "</h2>"));
                    }
                    lastContentGroup = entry.contentGroup;
                }
                var $selectable = _this.renderEntry(entry, selectCallback, highlight, searchQuery, deleteCallback, viewKeyMappings, accentColor, submitCallback, hideHandler, suggestRenderer);
                if (suggestLineCallback !== undefined) {
                    var suggestLineResult = suggestLineCallback($selectable.length > 0 ? $selectable.get()[0].outerHTML : '', entry.contentGroup, idx, entry);
                    if (suggestLineResult !== undefined) {
                        $selectable = sxQuery(suggestLineResult);
                        $selectable.on('click', function (e) {
                            if (entry.clickHandler !== undefined) {
                                var res = entry.clickHandler();
                                if (res) {
                                    hideHandler();
                                }
                            }
                            else {
                                selectCallback(entry, wrap, e);
                            }
                        });
                    }
                }
                _this.selectables.push($selectable);
                wrap.append($selectable);
            });
            if (!isFirstRender) {
                groupChangeCallback(oldSelectablesLength, _this.selectables.length);
            }
            isFirstRender = false;
        };
        if (this.categoryStyle === CategoryStyle.Tabs) {
            var groupedEntries_1 = this.dataSet.data.reduce(function (acc, entry) {
                acc['*'].push(entry);
                if (entry.contentGroup !== undefined) {
                    if (acc[entry.contentGroup] === undefined) {
                        acc[entry.contentGroup] = [];
                    }
                    acc[entry.contentGroup].push(entry);
                }
                return acc;
            }, { '*': [] });
            var groupKeys = Object.keys(groupedEntries_1).filter(function (key) {
                var viewKey = viewKeyMappings[key] !== undefined ? viewKeyMappings[key] : key;
                return viewKey !== undefined && viewKey.length > 0;
            });
            if (groupKeys.length > 2) { // length === 2 would mean that we have the all results tab + one additional tab containing all results
                var ul_1 = sxQuery('<ul role="tablist" class="unibox__menu-bar"></ul>');
                ul_1.attr('aria-label', this.config.suggestionsNavigationLabel);
                var buttonsMap_1 = {};
                groupKeys.forEach(function (key) {
                    var viewKey = viewKeyMappings[key] !== undefined ? viewKeyMappings[key] : key;
                    var isSelected = _this.activeContentGroup === key;
                    var activeClassName = isSelected ? " ".concat(ACTIVE_TAB_CLASS_NAME) : '';
                    var navigationButton = sxQuery("<button type=\"button\" role=\"tab\" class=\"unibox__menu-item".concat(activeClassName, " unibox-n-button\" aria-selected=\"").concat(isSelected, "\">").concat(viewKey, "</button>"));
                    buttonsMap_1[key] = navigationButton;
                    navigationButton.on('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (_this.activeContentGroup !== key) {
                            _this.selectables.forEach(function (selectable) {
                                selectable.remove();
                            });
                        }
                        _this.activeContentGroup = key;
                        Object.keys(buttonsMap_1).forEach(function (buttonKey) {
                            var $el = buttonsMap_1[buttonKey];
                            if (buttonKey === key) {
                                $el.addClass(ACTIVE_TAB_CLASS_NAME);
                                $el.attr('aria-selected', 'true');
                            }
                            else {
                                $el.removeClass(ACTIVE_TAB_CLASS_NAME);
                                $el.attr('aria-selected', 'false');
                            }
                        });
                        renderDataSet(groupedEntries_1[key]);
                    });
                    var navigationEntry = sxQuery('<li role="none"></li>');
                    navigationEntry.append(navigationButton);
                    ul_1.append(navigationEntry);
                });
                wrap.append(ul_1);
            }
        }
        renderDataSet(this.dataSet.data);
        if (this.isShowCta() && this.dataSet.data.length > 0) {
            var label = (this.layoutConfiguration.cta || '').replace(/#GROUP#/g, this.getResultGroup());
            var $cta_1 = sxQuery("<button type=\"button\" class=\"unibox-n-button unibox-tc-c unibox__selectable unibox__selectable--cta\" aria-selected=\"false\">".concat(label, "</button>"));
            $cta_1.on('click', function () {
                submitCallback($cta_1, _this.getResultGroup());
            });
            this.cta = $cta_1;
            wrap.append($cta_1);
        }
        return wrap;
    };
    SuggestionBlock.prototype.getResultGroup = function () {
        return this.dataSet.type === BlockEntryType.ResultGroup ? this.dataSet.data[0].contentGroup : undefined;
    };
    SuggestionBlock.prototype.renderEntry = function (entry, selectCallback, highlight, searchQuery, deleteCallback, viewKeyMappings, accentColor, submitCallback, hideHandler, suggestRenderer) {
        var _this = this;
        var additionalClassName = entry.className !== undefined ? " ".concat(entry.className) : '';
        var identifierAttr = entry.identifier !== undefined && entry.identifier !== null ? " data-ss360-identifier=\"".concat(entry.identifier, "\"") : '';
        var wrap;
        if (suggestRenderer === undefined) {
            wrap = sxQuery("<article class=\"unibox-n-section unibox__selectable".concat(additionalClassName, "\" aria-selected=\"false\" role=\"option\"").concat(identifierAttr, "></article>"));
            var contentWrap = sxQuery('<div class="unibox__content-container"></div>');
            var title_1 = entry.title;
            if (this.layoutConfiguration.showTitle && title_1 !== undefined) {
                contentWrap.append("<h3 class=\"unibox__selectable-title\">".concat(highlight ? StringHelper.highlightSearchWords(StringHelper.escapeHtml(title_1), searchQuery) : title_1, "</h3>"));
            }
            if (this.layoutConfiguration.showUrl && entry.link !== undefined) {
                contentWrap.append("<a href=\"".concat(entry.link, "\" class=\"unibox__selectable-link\">").concat(entry.link, "</a>"));
            }
            var snippet = entry.snippet;
            if (this.layoutConfiguration.showSnippet && snippet !== undefined) {
                snippet = snippet.split(/\n/g).join(' ');
                contentWrap.append("<p class=\"unibox__selectable-snippet\">".concat(highlight ? StringHelper.highlightSearchWords(snippet, searchQuery) : snippet, "</p>"));
            }
            if (this.dataPoints.length > 0 && entry.dataPoints !== undefined && entry.dataPoints.length > 0) {
                var dataPointsList_1 = sxQuery('<ul class="unibox__selectable-data-points"></ul>');
                var checkShowFlag_1 = entry.dataPoints.reduce(function (acc, dp) {
                    if (acc[dp.key] === undefined) {
                        acc[dp.key] = false;
                    }
                    acc[dp.key] = acc[dp.key] || dp.show;
                    return acc;
                }, {});
                var dataPointsMap_1 = entry.dataPoints.reduce(function (acc, dataPoint) {
                    if (acc[dataPoint.key] === undefined) {
                        acc[dataPoint.key] = [];
                    }
                    if (dataPoint.show || !checkShowFlag_1[dataPoint.key]) {
                        acc[dataPoint.key].push(dataPoint.value);
                    }
                    return acc;
                }, {});
                var dataPointAdded_1 = false;
                this.dataPoints.forEach(function (dataPoint) {
                    if (dataPointsMap_1[dataPoint.key] !== undefined) {
                        dataPointsMap_1[dataPoint.key].forEach(function (dp) {
                            dataPointAdded_1 = true;
                            var inner = "<span class=\"unibox__selectable-data-point-value\">".concat(dp, "</span>");
                            var additionalClass = '';
                            if (dataPoint.type === DataPointType.KeyValue) {
                                inner = "<strong class=\"unibox__selectable-data-point-key\">".concat(dataPoint.key, ":</strong> ").concat(inner);
                            }
                            if (dataPoint.type === DataPointType.Chip) {
                                additionalClass = "".concat(additionalClass, " unibox-ac-bg");
                            }
                            dataPointsList_1.append("<li class=\"unibox__selectable-data-point unibox__selectable-data-point--".concat(dataPoint.type).concat(additionalClass, "\">").concat(inner, "</li>"));
                        });
                    }
                });
                if (dataPointAdded_1) {
                    contentWrap.append(dataPointsList_1);
                }
            }
            if (entry.suggestionHtml !== undefined) {
                contentWrap.append("<span class=\"unibox__search-content\">".concat(entry.suggestionHtml, "</span>"));
            }
            var viewKey = viewKeyMappings[entry.contentGroup] !== undefined ? viewKeyMappings[entry.contentGroup] : entry.contentGroup;
            if (this.categoryStyle === CategoryStyle.Chips && viewKey !== undefined && viewKey.length > 0) {
                var $categoryButton_1 = sxQuery("<button type=\"button\" class=\"unibox-n-button unibox__selectable-category unibox-ac-bg\">".concat(viewKey, "</button>"));
                $categoryButton_1.attr('title', this.config.submitGroupLabel.replace(/#GROUP_NAME#/g, viewKey));
                $categoryButton_1.on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    submitCallback($categoryButton_1, entry.contentGroup);
                });
                var $categoryWrap = sxQuery('<div class="unibox__selectable-category-wrap"></div>');
                $categoryWrap.append($categoryButton_1);
                contentWrap.append($categoryWrap);
            }
            wrap.append(contentWrap);
            if (this.dataSet.type === BlockEntryType.SearchHistory) {
                var deleteButton = sxQuery("<button type=\"button\" class=\"unibox__delete-history unibox-n-button\">".concat(Icons.getSvgIcon(Icons.CROSS, '#626262', 'unibox__delete-history-icon'), "</button>"));
                deleteButton.attr('title', this.config.removeSuggestionLabel);
                deleteButton.on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    wrap.remove();
                    var idx = _this.selectables.indexOf(wrap);
                    _this.selectables.splice(idx, 1);
                    if (_this.selectables.length === 0 && _this.cta !== undefined) {
                        _this.cta.remove();
                    }
                    deleteCallback(title_1);
                });
                wrap.append(deleteButton);
            }
            var isCol = false;
            var imagePosition = this.layoutConfiguration.imagePosition;
            if (imagePosition !== ImagePosition.None && ((entry.image !== undefined && entry.image !== null) || this.layoutConfiguration.placeholderImage !== undefined)) {
                var image = entry.image || this.layoutConfiguration.placeholderImage;
                isCol = imagePosition === ImagePosition.Top || imagePosition === ImagePosition.Bottom;
                var imgWrap = sxQuery("<div class=\"unibox__selectable-image-container unibox__selectable-image-container--".concat(imagePosition, "\"></div>"));
                var imageIconClass = '';
                if (UiHelper.isDocIcon(image)) {
                    imageIconClass = ' unibox__selectable-image--doc-icon';
                }
                var img_1 = sxQuery("<img src=\"".concat(image, "\" class=\"unibox__selectable-image").concat(imageIconClass, "\" alt aria-hidden=\"true\" role=\"presentation\">"));
                imgWrap.append(img_1);
                if (imagePosition === ImagePosition.Bottom || imagePosition === ImagePosition.Right) {
                    wrap.append(imgWrap);
                }
                else {
                    wrap.prepend(imgWrap);
                }
                wrap.addClass('unibox__selectable--has-image');
                img_1.on('error', function () {
                    img_1.hide();
                });
            }
            else if ((this.layoutConfiguration.icon || '').length > 0) {
                var icon = this.layoutConfiguration.icon;
                var iconWrap = sxQuery('<div class="unibox__selectable-icon-container"></div>');
                if (icon === 'ss360:search') {
                    iconWrap.append(Icons.getSvgIcon(Icons.MAGNIFIER, accentColor, 'ss360-block', 16, 16));
                }
                else if (icon === 'ss360:history') {
                    iconWrap.append(Icons.getSvgIcon(Icons.HISTORY, '#a1a7b9', 'ss360-block', 16, 16));
                }
                else {
                    try {
                        iconWrap.append(icon);
                    }
                    catch (err) {
                        // ccl
                    }
                }
                wrap.prepend(iconWrap);
            }
            if (isCol) {
                wrap.addClass('unibox__selectable--col');
            }
        }
        else {
            if (entry.title !== undefined && entry.title !== '') {
                entry.highlightedName = StringHelper.highlightSearchWords(entry.title, searchQuery);
            }
            if (entry.snippet !== undefined && entry.snippet !== '') {
                entry.highlightedContent = StringHelper.highlightSearchWords(entry.snippet, searchQuery);
            }
            // @ts-ignore
            var suggestObj = __assign(__assign({}, entry), { name: entry.title, type: SuggestType.HTML, content: entry.snippet });
            wrap = suggestRenderer.render(new SearchSuggest(suggestObj), this.activeContentGroup, false, true);
        }
        wrap.on('click', function (e) {
            if (entry.clickHandler !== undefined) {
                var res = entry.clickHandler();
                if (res) {
                    hideHandler();
                }
            }
            else {
                selectCallback(entry, wrap, e);
            }
        });
        return wrap;
    };
    SuggestionBlock.prototype.highlight = function (idx) {
        if (this.isCta(idx)) { // cta is focused
            Helper.addHighlight(this.cta);
            return;
        }
        var selectable = (this.selectables || [])[idx];
        if (selectable !== undefined) {
            Helper.addHighlight(selectable);
        }
    };
    SuggestionBlock.prototype.removeHighlight = function () {
        (this.selectables || []).forEach(function (selectable) {
            Helper.removeHighlight(selectable);
        });
        if (this.cta !== undefined) {
            Helper.removeHighlight(this.cta);
        }
    };
    SuggestionBlock.prototype.length = function () {
        return this.dataSet.data.length + (this.isShowCta() ? 1 : 0);
    };
    SuggestionBlock.prototype.isCta = function (idx) {
        return this.isShowCta() && this.cta !== undefined && idx === (this.selectables || []).length;
    };
    SuggestionBlock.prototype.get = function (idx) {
        return this.dataSet.data[idx];
    };
    SuggestionBlock.prototype.getSelectable = function (idx) {
        return this.selectables[idx];
    };
    SuggestionBlock.prototype.getColumnCount = function (staticLayout) {
        if (staticLayout === void 0) { staticLayout = false; }
        if (!staticLayout && this.dataSet.data.length === 0 && !this.empty) {
            return 0;
        }
        // 1=respect css; 2=stretch
        return this.layoutConfiguration.type === SuggestLayoutType.HorizontalList ? 2 : 1;
    };
    SuggestionBlock.prototype.setEmpty = function (empty) {
        this.empty = empty;
    };
    return SuggestionBlock;
}());
export default SuggestionBlock;
